// Lightweight mouse-tracked 3D tilt, shared by every premium card on the
// HKI Animatica page (an-tilt class). Kept as plain event handlers rather
// than a full hook so it can be spread directly onto any element:
//   <div className="an-tilt" {...tiltHandlers} />
const MAX_TILT = 10;

export function handleTiltMove(event) {
  const el = event.currentTarget;
  const rect = el.getBoundingClientRect();
  const px = (event.clientX - rect.left) / rect.width;
  const py = (event.clientY - rect.top) / rect.height;
  const rotateY = (px - 0.5) * MAX_TILT * 2;
  const rotateX = (0.5 - py) * MAX_TILT * 2;
  el.style.transform = `perspective(900px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) translateY(-6px) scale(1.02)`;
  el.style.setProperty("--an-glare-x", `${px * 100}%`);
  el.style.setProperty("--an-glare-y", `${py * 100}%`);
  el.style.setProperty("--an-glare-o", "1");
}

export function handleTiltLeave(event) {
  const el = event.currentTarget;
  el.style.transform = "";
  el.style.setProperty("--an-glare-o", "0");
}

export const tiltHandlers = {
  onMouseMove: handleTiltMove,
  onMouseLeave: handleTiltLeave,
};
